// Shows or hides the home page banner entirely when set to true/false
export const BANNER_ENABLED = true
// Sets the link destination for the banner component, or renders the banner as
// plain, un-clickable text if set to a falsey value (`false`, `null`, '', etc...)
export const BANNER_LINK_URL =
	'https://vote.kwenta.eth.limo/#/proposal/0xdd2938c31afbadf4a4b930f5be156b6af89198d22788e5ab90776cf67ffe8c99'
// Sets the text displayed on the home page banner
export const BANNER_TEXT =
	'Kwenta Council elections are live. See Discord for nominations. All Kwenta stakers are eligible to vote ↗'
// Sets the height of the banner component on desktop
export const BANNER_HEIGHT_DESKTOP = 50
// Sets the height of the banner component on mobile
export const BANNER_HEIGHT_MOBILE = 85
// Sets the waiting time of the banner component before it is reactive
export const BANNER_WAITING_TIME = 0
